// eslint-disable-next-line consistent-return
export default (...guards) => (to, from, next) => {
  guards.forEach((guardFunc) => guardFunc(to, from, next));
};
